/**
 * @author      Dario Casertano <dario@casertano.name>
 * @copyright   Copyright (c) 2021 Casertano Dario – All rights reserved.
 * @license     Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International.
 */

import { settings } from "@/libraries/storage";
import { NavigationGuardNext, Route } from "vue-router/types/router";

export const beforeEnterWatcher = async (to: Route, from: Route, next: NavigationGuardNext): Promise<void> => {
    if (!settings.has('auth', 'user', 'token')) {
        next({
            path: '/login',
            query: {
                redirectTo: to.fullPath,
            }
        });
    } else {
        next();
    }
}
